import { AddBahasaPayload, EditBahasaPayload } from "../../../../models/Bahasa";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";
import { allBahasaKey } from "../../queries/Bahasa/useFetchAllBahasa";
import getQueryClient from "../../queryClient";

export async function editBahasa(data: EditBahasaPayload) {
  const res = await ApiClient.put(`/EditBahasa`, data);
  return res.data;
}

export const useEditBahasa = mutationWrapper(editBahasa, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(allBahasaKey);
  },
});
